<template>

  <div>
    <v-select
      :value="selected"
      @input="change"
      :multiple="true"
      :options="options"
      :placeholder="placeholder">
      </v-select>
  </div>

</template>

<script>
export default {
  name: 'SelectTags',
  props: {
    value: {
      type: Array,
      default: () => { return [] }
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      tags: [],
      loading: true
    }
  },
  computed: {
    options () {
      return this.tags.map((val) => {
        return {
          label: val.name,
          value: val.name
        }
      })
    },
    selected () {
      return this.value.map(v => {
        return this.options.find(o => o.value === v)
      }).filter(v => v)
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.$store
      .dispatch('getTags', {
        type: 'candidate',
        sort: 'name',
        limit: 1000
      })
      .then(result => {
        this.tags = result.docs
        this.loading = false
      })
    },
    change (val) {
      const value = val ? val.map(v => v.value) : []
      if (JSON.stringify(value) !== JSON.stringify(this.value) && !this.loading) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Fields/SelectTags.vue